import ListGroup from "./ListGroup.vue";
import ListGroupItem from "./ListGroupItem.vue";
import { pluginify } from "./../../util";
export default pluginify(ListGroup, ListGroupItem);
export { ListGroup, ListGroupItem };
